<template>
  <div>
    <div>
      <form>
        <div>
          <label for="liste">Liste :</label>
          <div v-if="!libellesTabledesvaleursLoading" class="col">
            <Dropdown
                v-model="tabledesvaleurs"
                :options="tabledesvaleursLibelles"
                :showClear="true"
                :filter="true"
                optionValue="valeur"
                optionLabel="texte"
                @change="onChange($event)"
                scrollHeight="205px"/>
          </div>
          <div v-else class="col">
            <vue-loaders name="ball-beat" class="justify-center"></vue-loaders>
          </div>
        </div>
        <div class="row">
          <div class="col-4 lbl">
          </div>

        </div>

        <div>
          <label for="role">Rôle :</label>
          <input type="text" id="role" name="role">
        </div>

        <div>
          <input type="checkbox" id="aide" name="aide" checked>
          <label for="aide">Afficher l'aide en ligne</label>
        </div>

        <div>
          <input type="checkbox" id="anglais" name="anglais" checked>
          <label for="anglais">Afficher la section en anglais</label>
        </div>

        <div class="row">
          <div class="col">
            <Button @click="rechercher"> Rechercher </Button>
          </div>
          <div class="col" >
            <Button @click="effacerCriteres"> Effacer critères </Button>
          </div>
          <div class="col" >
            <Button @click="ajouter"> Ajouter </Button>
          </div>
          <div class="col">
            <Button @click="fermer"> Fermer </Button>
          </div>

        </div>

      </form>
    </div>
    <hr>
  </div>
</template>


<script>
import {mapGetters} from "vuex";
import axios from 'axios';

export default {
  emits: ['rechercher'],
  data() {
    return {
      tabledesvaleurs: null,
      tabledesvaleursLibelles: [],
      libellesTabledesvaleursLoading: false,
      role: null
    };
  },

  computed: {
    ...mapGetters({
      jeton: "cardex/jeton",
      profil: 'cardex/profil',
    }),
  },

  mounted() {
    axios.defaults.headers.common['cleProfil'] = this.profil.cle;
    this.libellesTabledesvaleursLoading = true;
    this.$store.dispatch("pilotage/rechercherTableValeurSansAscAction", 'TableValeur').then((res) => {
      this.tabledesvaleursLibelles = res.data;
      console.log("Données récupérées :", this.tabledesvaleursLibelles);
      this.tabledesvaleursLibelles.sort(function (a, b) {
        if (a.texte < b.texte) {
          return -1;
        }
        if (a.texte > b.texte) {
          return 1;
        }
        return 0;
      });
      this.libellesTabledesvaleursLoading = false;
    });
  },
  methods: {
    onChange(event) {
      this.tabledesvaleursLibelles.forEach((codeEnfant) => {
        if (event.value == codeEnfant.valeur) {
          this.role = codeEnfant.role
        }
      })
    },

    rechercher() {
      let libelleRecherche = {};
      libelleRecherche.valeur = this.tabledesvaleurs; // La valeur principale est la liste
      libelleRecherche.enfant = {};
      libelleRecherche.enfant.code = this.role; // L'enfant a pour valeur le rôle

      this.$emit('rechercher', libelleRecherche);
    },
  }
};




</script>

<style scoped>
.container {
  text-align: center;
  margin-top: 50px;
}
</style>
